import AdminCreatePostModal from './AdminCreatePostModal';

export default AdminCreatePostModal;
